import EnvironmentService from "./environmentService";

export default class VersionService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveBackendVersion() {
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Test/Version");

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/versionService.js